import { CategoryTag, CustomCategoryHierarchy, PageNumbers } from '@catalog/const';
import { StateUtils } from '@spartacus/core';

export const CATALOG_FEATURE = 'customCatalog';
export const PRODUCT_MENU = '[CustomCatalog] Product Menu';
export const REVIEWS = '[CustomCatalog] Reviews';
export const ADD_REVIEW = '[CustomCatalog] Add review';
export const PRODUCT_LIST_REVIEW = '[CustomCatalog] Product List Review';
export const CATEGORY_TAGS = '[CustomCatalog] Category Tags';
export const CATEGORY_TAG_ITEM = '[CustomCatalog] Category Tag Item';
export const CATEGORY_DETAILS = '[CustomCatalog] Category Details';

export interface ProductListLoadingState {
  loading?: boolean;
  loadingMore?: boolean;
  loadingSuggestions?: boolean;
  pageNumbers?: PageNumbers;
}

export interface CategoryTagsState {
  items: StateUtils.EntityLoaderState<CategoryTag[]>;
  activeItem: StateUtils.LoaderState<CategoryTag>;
}

export interface CatalogState {
  productListLoading: ProductListLoadingState;
  categoryTags: CategoryTagsState;
  categoryDetails: StateUtils.LoaderState<CustomCategoryHierarchy>;
}

export interface StateWithCatalog {
  [CATALOG_FEATURE]: CatalogState;
}
